/**
 * Safe JSON-LD structured data component.
 * Centralizes all <script type="application/ld+json"> rendering.
 * JSON.stringify on developer-defined objects is inherently safe
 * (produces valid JSON, cannot contain executable HTML/JS).
 */
export function JsonLd({ data }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
